export { OrderStatusCode, OrderStatusDetails, getOrderStatusColor } from 'interfaces/orderStatus';
export type { OrderStatusDetails as OrderStatusDetailsInterface } from 'interfaces/orderStatus';

import { OrderStatusCode, OrderStatusDetails } from 'interfaces/orderStatus';

export interface OrderStatusDto {
  id: number;
  name: keyof typeof OrderStatusCode; // Ensure name field is a string version of the enum
  enabled: boolean;
  defaultOrderStatus: boolean;
  ordinal: number;
}

export interface OrderStatus {
  id: number;
  code: OrderStatusCode;
  details: (typeof OrderStatusDetails)[OrderStatusCode];
  enabled: boolean;
  defaultOrderStatus: boolean;
  ordinal: number;
}

export function convertOrderStatusDtoToDomain(orderStatusDto: OrderStatusDto): OrderStatus {
  const statusCode = OrderStatusCode[orderStatusDto.name as keyof typeof OrderStatusCode]; // Use enum string key

  return {
    id: orderStatusDto.id,
    code: statusCode,
    details: OrderStatusDetails[statusCode],
    enabled: orderStatusDto.enabled,
    defaultOrderStatus: orderStatusDto.defaultOrderStatus,
    ordinal: orderStatusDto.ordinal,
  };
}
